export const resizeImage = async (
	file: File,
	width: number,
	height: number,
): Promise<File> => {
	const form = new FormData()
	form.append('file', file)
	form.append('width', width.toString())
	form.append('height', height.toString())

	const res = await fetch('/api/resize-image', {
		method: 'POST',
		body: form,
	})

	if (!res.ok) {
		throw new Error('Resize failed')
	}

	const blob = await res.blob()
	return new File([blob], file.name, { type: file.type })
}
